import React from "react";
import { Stack, TextField } from "@mui/material";
import MuiTypographyMandatory from "./MuiTypographyMandatory";
import { VM_Colors } from "../../Styles/VMStyles";
import { handleWheel, toTitleCase } from "../../Util/UtilHelper";

const StyledInputField = ({
  heading,
  placeholder = "",
  required = false,
  value,
  onChange,
  name,
  type,
  style,
  disabled = false,
  ...rest
}) => {
  // Prevent scroll from changing number input value and block arrow keys
  const handleKeyDown = (e) => {
    const isNumeric = type === 'number' || (rest && rest.inputProps && rest.inputProps.inputMode === 'numeric');
    if (isNumeric && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
      e.preventDefault();
    }

    if (rest && typeof rest.onKeyDown === 'function') rest.onKeyDown(e);
  };

  return (
    <Stack spacing={heading ? 0.5 : 0} sx={{ minWidth: 0, width: "100%" }}>
      {heading ? (
        <MuiTypographyMandatory label={heading} required={required} />
      ) : null}

      <TextField
        variant="outlined"
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        placeholder={toTitleCase(placeholder)}
        type={type}
        disabled={disabled}
        onWheel={handleWheel}
        onKeyDown={handleKeyDown}
        InputLabelProps={{ shrink: !!value }}
        style={style}
        sx={{
          backgroundColor: VM_Colors.white,
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px",
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: "16px",
            backgroundColor: VM_Colors.white,
    "& fieldset": {
      borderColor: "#C3C3C3",
    },
    "&:hover fieldset": {
      borderColor: "#A0A0A0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1E3A8A",
    },
  },

  /* ✅ REMOVE NUMBER INPUT ARROWS */
  "& input[type=number]": {
    MozAppearance: "textfield", // Firefox
  },
  "& input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "& input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },

  "& .MuiInputBase-input::placeholder": {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "16px",
    color: VM_Colors.steel_gray,
    opacity: 1,
  },
        }}

        {...rest}
      />
    </Stack>
  );
};

export default StyledInputField;